import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Matches US phone numbers in common formats: (866)790-4254, (866) 790-4254,
 * 866-790-4254, 866.790.4254, 8667904254, etc.
 * Negative lookbehind avoids matching numbers already inside an <a> tag href.
 */
const PHONE_REGEX = /(?<!["\w/+])(\(?\d{3}\)?[\s.\u002D]?\d{3}[\s.\u002D]?\d{4})(?!["\d])/g;

function linkifyPhoneNumbers(html: string): string {
  // Skip linkification if the matched phone is already inside an <a> tag
  return html.replace(PHONE_REGEX, (match) => {
    const digits = match.replace(/\D/g, '');
    // Only linkify 10-digit US phone numbers
    if (digits.length !== 10) return match;
    const tel = `tel:+1${digits}`;
    return `<a href="${tel}" class="text-ld-link font-medium hover:underline cursor-pointer whitespace-nowrap">${match}</a>`;
  });
}

@Pipe({
  name: 'safeHtml',
})
export class SafeHtmlPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  transform(value: string | null | undefined): SafeHtml {
    let html = value ?? '';
    // Auto-linkify phone numbers that are not already wrapped in anchor tags
    if (html && !html.includes('tel:')) {
      html = linkifyPhoneNumbers(html);
    }
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
